var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import styled from 'styled-components';
import Trigger from 'rc-trigger';
import { placementBaseConfig, BaseTooltipContainer, BaseTooltipArrow, } from './util';
import { Color } from '../const';
import './index.css';
var getPopupElement = function (props) {
    var CustomArrow = props.CustomArrow, CustomTooltipContainer = props.CustomTooltipContainer, overlay = props.overlay;
    return [
        React.createElement(CustomArrow, { key: "arrow" }),
        React.createElement(CustomTooltipContainer, { key: "content" }, overlay),
    ];
};
function Tooltip(props) {
    var restProps = {};
    if ('visible' in props && typeof props.visible === 'boolean') {
        restProps.popupVisible = props.visible;
    }
    var placement = props.placement, placementConfig = props.placementConfig, trigger = props.trigger, getTooltipContainer = props.getTooltipContainer, onVisibleChange = props.onVisibleChange;
    return (React.createElement(Trigger, __assign({}, props, { action: trigger, builtinPlacements: placementConfig, destroyPopupOnHide: false, getPopupContainer: getTooltipContainer, onPopupVisibleChange: onVisibleChange, popup: function () { return getPopupElement(props); }, popupPlacement: placement, popupStyle: { color: 'gray' }, prefixCls: "air-kit-tooltip", overlayClassName: "air-kit" }, restProps), props.children));
}
var TooltipContainer = styled(BaseTooltipContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), Color.WHITE);
var StyledArrow = styled(BaseTooltipArrow)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: ", ";\n"], ["\n  background: ", ";\n"])), Color.WHITE);
Tooltip.defaultProps = {
    CustomTooltipContainer: TooltipContainer,
    CustomArrow: StyledArrow,
    mouseEnterDelay: 0,
    mouseLeaveDelay: 0.1,
    onVisibleChange: function () { },
    placement: 'right',
    placementConfig: placementBaseConfig,
    trigger: ['hover'],
};
export default Tooltip;
var templateObject_1, templateObject_2;
//# sourceMappingURL=tooltip.js.map